import { useEffect, useContext } from 'react';
import { AppContext } from '../context/AppContext';
import axios from 'axios';

const useCourseRetriever = (courseId, time = '') => {
  const { appState, appDispatch } = useContext(AppContext);

  useEffect(() => {
    console.log('Fetching course info');
    const VARS = appState.envVars;
    const ROOT_URL = VARS.ROOT_URL;
    const COURSE_URL = ROOT_URL + VARS.COURSE_API;

    appDispatch({ type: 'setCourseLoading' });
    const nonce = window.ttnonce || window.TTI_REST_NONCE;

    axios
      .get(COURSE_URL + courseId + '/?_wpnonce=' + nonce)
      .then((val) => {
        if (val.data.error || !val.data.course) {
          appDispatch({
            type: 'setCourseError',
            error: `Unable to load course`,
          });
        } else {
          appDispatch({
            type: 'setCourse',
            course: val.data.course,
          });
          appDispatch({
            type: 'setLatestLesson',
            latestLesson: val.data.latestLesson,
          });
          appDispatch({
            type: 'setLessonsLocked',
            lessonsLocked: val.data.lessonsLocked,
          });
          appDispatch({
            type: 'setCoursePurchased',
            isCoursePurchased: val.data.userEnrolled,
          });
          appDispatch({
            type: 'setCourseFree',
            isCourseFree: val.data.course.price === 0,
          });
          appDispatch({
            type: 'setUserLoggedIn',
            userLoggedIn: val.data.userLoggedIn,
          });
        }
      })
      .catch((err) => {
        appDispatch({
          type: 'setCourseError',
          error: err.message,
        });
      });
  }, [courseId, appDispatch, appState.envVars, appState.cachingVersion, time]);
};

export default useCourseRetriever;
